import { Game, createUnblockGameMutation } from 'shared/api';
import { ConfirmModalModel, createConfirmModalModel, declareModalData } from 'shared/lib';

export type UnblockGameModel = ConfirmModalModel<Game, number, null>;

export const createUnblockGameModel = (): UnblockGameModel => {
	const unblockGameMutation = createUnblockGameMutation();

	const model = createConfirmModalModel<Game, number, null>({
		modalData: declareModalData<Game>(),
		mapModalData: ({ id }) => id,
		mutation: unblockGameMutation,
		successMessageKey: 'unblock-game.success',
	});

	return model;
};
